import { Injectable } from "@angular/core";
import { CalibrationType } from "src/app/calibration/_interfaces/ratings-data.interface";

@Injectable({ providedIn: 'root' })
export class ViewStateService {
    private _viewType: CalibrationType = CalibrationType.Curve;

    set(viewType: CalibrationType) {
        console.log("Setting view type:", viewType);
        this._viewType = viewType;
    }

    get(): CalibrationType | null {
        console.log("Getting view type:", this._viewType);
        return this._viewType;
    }

    clear() {
        console.log("Cleaning view type");
        this._viewType = null;
    }
}
